<template>
  <!--Download start-->
  <section class="download-bg" ref="downloadPosition">
    <div class="container">
      <div class="row">
        <div class="col-xl-3 display-flex">
          <div class="footer-logo">
            <img
              src="../assets/images/footer-logo.png"
              alt="footer-logo"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-xl-5 display-flex">
          <div class="download-text">
            <h3>Download the Chatloop app and enjoy it</h3>
          </div>
        </div>
        <div class="col-xl-4 display-flex">
          <div class="download-img">
            <ul>
              <li>
                <img
                  src="../assets/images/app1.png"
                  alt="foot-app"
                  class="img-fluid"
                  data-tilt
                  data-tilt-perspective="50"
                  data-tilt-speed="350"
                  data-tilt-max="1.8"
                />
              </li>
              <li>
                <img
                  src="../assets/images/app2.png"
                  alt="foot-app1"
                  class="img-fluid"
                  data-tilt
                  data-tilt-perspective="50"
                  data-tilt-speed="350"
                  data-tilt-max="1.8"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--Download end -->
</template>
<script>
export default {
  name: "Download",
  mounted() {
    let payload = {
      position: this.$refs["downloadPosition"].offsetTop,
      name: "downloadPosition",
    };
    this.$emit("windowPosition", payload);
  },
};
</script>
